import { Strings } from "src/modules/utils/shared/strings";
import { NetworkLinkedDocumentShareType } from "./NetworkLinkedDocumentShareType";
import { NetworkLinkedDocumentCategory } from "./NetworkLinkedDocumentCategory";
import { Type } from "class-transformer";

export class NetworkLinkedDocument {
    //netgen start
    title: string;
    filePath: string;
    categoryId: number = null;
    @Type(() => NetworkLinkedDocumentCategory)
    category: NetworkLinkedDocumentCategory;
    createdById = 0;
    shareType: NetworkLinkedDocumentShareType = NetworkLinkedDocumentShareType.private;
    forUsersIds: number[];
    id = 0;
    //netgen end

    canDownload(): boolean {
        return Strings.endsWithCi(this.filePath, ".pdf");
    }
}
